
(() => {
  class MediaCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-track]');
      this.inner = this.querySelector('.mc__inner');
      if (!this.track) return;

      this.originals = Array.from(
        this.track.querySelectorAll('[data-slide]')
      );
      this.n = this.originals.length;
      this.speed = parseFloat(this.dataset.speed) || 60;
      this.gap = parseFloat(this.dataset.gap) || 0;
      this.reduced = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.build = this.build.bind(this);

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => {
          clearTimeout(this.rt);
          this.rt = setTimeout(this.build, 120);
        });

        this.ro.observe(this.inner || this);
      }

      this.build();
    }

    disconnectedCallback() {
      clearTimeout(this.rt);
      if (this.ro) this.ro.disconnect();
    }

    spv() {
      const width = window.innerWidth;

      if (width >= 990) {
        return parseFloat(this.dataset.spvD) || 5;
      }

      if (width >= 750) {
        return parseFloat(this.dataset.spvT) || 3;
      }

      return parseFloat(this.dataset.spvM) || 1.5;
    }

    makeClone(source) {
      const clone = source.cloneNode(true);

      clone.removeAttribute('data-slide');
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('a, button').forEach((element) => {
        element.tabIndex = -1;
      });

      clone.querySelectorAll('img').forEach((img) => {
        img.loading = 'lazy';
        img.decoding = 'async';
        img.removeAttribute('fetchpriority');
      });

      return clone;
    }

    build() {
      if (!this.n) return;

      const width = (this.inner || this).clientWidth;
      if (!width) return;

      this.track.querySelectorAll('[data-clone]').forEach((clone) => {
        clone.remove();
      });

      const spv = this.spv();
      const slideWidth = Math.max(
        40,
        (width - this.gap * (spv - 1)) / spv
      );

      this.style.setProperty('--mc-w', slideWidth + 'px');

      const shift = this.n * (slideWidth + this.gap);
      this.style.setProperty('--mc-shift', shift + 'px');
      this.style.setProperty('--mc-dur', (shift / this.speed) + 's');

      if (this.n < 2 || this.reduced) {
        this.classList.remove('is-ready');
        return;
      }

      const extraSets = Math.ceil(width / shift) + 1;
      const fragment = document.createDocumentFragment();

      for (let set = 0; set < extraSets; set++) {
        this.originals.forEach((original) => {
          fragment.appendChild(this.makeClone(original));
        });
      }

      this.track.appendChild(fragment);
      this.classList.add('is-ready');
    }
  }

  if (!customElements.get('media-carousel')) {
    customElements.define('media-carousel', MediaCarousel);
  }
})();
